import styled, {keyframes} from 'styled-components';
import Image from '@stencil/image';

const fadeIn = keyframes`
from{
  opacity: 0;
  transform: scale(0);
  transform-origin: center center;
}
to{
  opacity: 1;
  transform: scale(1);
  transform-origin: center center;
}
`;

export const VideoLandscapeImageWrapper = styled.div(
  props => `
    position:relative;
    > svg {
      position:absolute;
      top:${props.playIconTop || '50%'};
      left:${props.playIconLeft || '50%'};
    }
  `,
);

export const CaptivateLandscapeImage = styled(Image)`
  width: 100%;
  height: 40.9rem;
  object-fit: contain;
  border-radius: ${props => props.theme.misc.borderRadius.xlarge};
  user-select: none;
  cursor: pointer;
  margin-bottom: ${props => props.theme.spacing.base};
  animation: ${fadeIn} 0.5s ease-in-out forwards;
  margin-top: ${props => props.theme.spacing.base};
`;

export const CaptivateCardImage = styled(Image)(
  props => `
    width: ${props.width || '49.5%'};
    height: 21.2rem;
    object-fit: cover;
    border-radius:${props.theme.misc.borderRadius.xlarge};
    cursor:pointer;
    `,
);

export const CaptivatePotraitImage = styled(Image)(
  props => `
    width: ${props.width || '49.5%'};
    height: 43.9rem;
    object-fit: cover;
    border-radius:${props.theme.misc.borderRadius.xlarge};
    cursor:pointer;
    `,
);

export const CaptivateImageGridContainer = styled.div(
  props => `
    display: flex;
    justify-content: space-between;
    // margin-top: ${props.theme.spacing.small};
    cursor:pointer;
    gap:12px;
    `,
);

export const CaptivateImageGridThreeContainer = styled.div(
  props => `
    display: flex;
    >img{
      margin-bottom: ${props.theme.spacing.custom(12)};
      cursor:pointer;
    }

    >div{
      margin-bottom: ${props.theme.spacing.custom(12)};
    }
    `,
);

export const CaptivateGridContainer = styled.div(
  props => `
    margin-top: 5rem;
    -ms-overflow-style: none;  
    scrollbar-width: none;
    >div{
      &::-webkit-scrollbar {
        display: none;
      }
    }
    
    `,
);

export const CaptivateImageGridInnerWrap = styled.div(
  props => `
    display: flex;
    flex-direction:column;
    width:50%;
    margin-right:${props.theme.spacing.custom(12)};
    cursor:pointer;
    &:last-child{
      margin-right:0;
    }
    >img{
        width:100%;
        margin-bottom: ${props.theme.spacing.custom(12)};
    }
    >div{
      width:100%;
      margin-bottom: ${props.theme.spacing.custom(12)};
  }
  >div >img{
    width:100%;
    margin-bottom: ${props.theme.spacing.custom(12)};
}
    `,
);
